import base, { ApiTag } from './base';
import Widget from '@enview/interface/types/Widget';

interface CreateWidgetParams {
  orgId: number;
  name: string;
  description?: string;
  viewId: number;
  primaryColor: string;
}

interface UpdateWidgetParams {
  orgId: number;
  id: number;
  name?: string;
  description?: string;
  primaryColor?: string;
  allowedOrigin?: string | null;
  isActive?: boolean;
}

const widgetAPI = base.injectEndpoints({
  endpoints: (build) => ({
    listWidgets: build.query<Widget[], number>({
      query: (orgId) => ({
        url: `/v2/widgets/${orgId}`,
        method: 'GET',
      }),
      providesTags: [{ type: ApiTag.WIDGET }],
    }),
    createWidget: build.mutation<Widget, CreateWidgetParams>({
      query: ({ orgId, ...data }) => ({
        url: `/v2/widgets/${orgId}`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [ApiTag.WIDGET],
    }),
    updateWidget: build.mutation<Widget, UpdateWidgetParams>({
      query: ({ orgId, id, ...data }) => ({
        url: `/v2/widgets/${orgId}/${id}`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [ApiTag.WIDGET],
    }),
    deleteWidget: build.mutation<void, { orgId: number; id: number }>({
      query: ({ orgId, id }) => ({
        url: `/v2/widgets/${orgId}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [ApiTag.WIDGET],
    }),
  }),
  overrideExisting: false,
});

export default widgetAPI;
